export default "__VITE_ASSET__CSL6l2eV__"